/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { Alert } from '../../shared/alert/alert';
export const T2CMultiPendingAlert = ({ numberOfPendingT2CAuthContacts, numberOfContacts, onClickResend, }) => {
    return (React.createElement(Alert, { status: "info" },
        React.createElement("div", { className: "sui-grid sui-justify-items-start sui-gap-4" },
            React.createElement(Typography, { variant: "body-base" },
                numberOfPendingT2CAuthContacts,
                " of ",
                numberOfContacts,
                " Text2Confirm Invites Pending Acceptance"),
            React.createElement(Link, { component: "button", onClick: onClickResend }, "Resend Invites"))));
};
